import { qsa, add, remove, contains } from "@fluorescent/dom";
import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  megaNavs: ".mega-navigation-wrapper",
  animationItems: `
    .mega-navigation__list-parent,
    .image, .placeholder-svg,
    .mega-navigation__featured-content,
    .mega-navigation__feature-text
    `,
};

const classes = {
  visible: "visible",
  animationRevealed: "animation--revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;

  const megaNavs = qsa(selectors.megaNavs, node);
  megaNavs.forEach(megaNav => {
    delayOffset(megaNav, [selectors.animationItems]);
  });

  // Trigger the reveal animation when the drawer is opened
  function open(menu) {
    add(menu, classes.animationRevealed);
  }

  // Reset the reveal animation when the drawer is closed
  function close(menu) {
    // remove(menu, classes.animationRevealed);
    if (!contains(menu, classes.visible)) {
      remove(menu, classes.animationRevealed);
    }
  }

  return {
    open,
    close,
  };
};
